import * as React from 'react';

import { useIntl } from 'react-intl';
import { Outlet, useParams } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import Tab from 'src/components/navigation/Tab';
import TabRow from 'src/components/navigation/TabRow';
import { RESERVATION_TYPE } from 'src/features/reservations/types/reservationType';
import { reservationMessages } from 'src/features/reservations/utils/messages';
import { useTitleStore } from 'src/stores/useTitleStore';

const ReservationTypesLayout = () => {
    const { parkingId } = useParams();
    const { reservationType } = useParams();
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        if (!reservationType) return;
        setTitle(formatMessage(reservationMessages[reservationType as RESERVATION_TYPE]));
        return () => removeTitle();
    }, [reservationType, formatMessage]);

    return (
        <>
            <TabRow>
                <Tab end to={`/parking-management/${parkingId}/reservations/dynamic`}>
                    {formatMessage(reservationMessages.dynamicPlans)}
                </Tab>
                <Tab to={`/parking-management/${parkingId}/reservations/fixed`}>
                    {formatMessage(reservationMessages.fixedPlans)}
                </Tab>
            </TabRow>

            <MainLayout>
                <Outlet />
            </MainLayout>
        </>
    );
};

export default ReservationTypesLayout;
